import {NgModule} from '@angular/core';
import {PersonalDetailsPageComponent} from './personal-details-page.component';
import {PageCommonModule} from '../shared/page-common.module';
import {BasicInfoScreenComponent} from './steps/basic-info/basic-info-screen.component';
import {ContactScreenComponent} from './steps/contact/contact-screen.component';
import {IdentificationScreenComponent} from './steps/identification/identification-screen.component';
import {FormsModule} from '../../components/forms/forms.module';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {PersonalDetailsSectionService} from './model/personal-details-section.service';
import {StepScreenModule} from '../shared/step/step-screen.module';
import {AdminReportsScreenComponent} from './steps/admin-reports/admin-reports-screen.component';
import {FileListModule} from '../../components/files/file-list/file-list.module';
import {FileUploaderModule} from '../../components/files/file-uploader/file-uploader.module';
import {ProfileStatusModule} from '../../components/profile-status/profile-status.module';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        StepScreenModule,
        NgbDatepickerModule,
        FileListModule,
        FileUploaderModule,
        ProfileStatusModule,
    ],
    declarations: [
        PersonalDetailsPageComponent, BasicInfoScreenComponent, ContactScreenComponent, IdentificationScreenComponent, AdminReportsScreenComponent
    ],
    providers: [PersonalDetailsSectionService]
})
export class PersonalDetailsPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/personal-details/personal-details-page.module.ts